// Definición de defaults

export const defaultTipoFormato: TipoFormatoProps = {
    idTipoFormato:    0,
    descripcion:    '',
    activo:         false,
}

// Creación de interfaces

export interface TipoFormatoProps {
    idTipoFormato:    number;
    descripcion:    string;
    activo:         boolean;
}